export const NOTIFY_STATUS_LIST_MUTATION = "NOTIFY_STATUS_LIST_MUTATION";
export const NOTIFY_TYPE_LIST_MUTATION = "NOTIFY_TYPE_LIST_MUTATION";
